// instrumentation-client.js
/*
import posthog from "posthog-js";

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
  api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST!,
  autocapture: false,
  capture_performance: false,
  capture_pageview: false,
  capture_pageleave: false,
  capture_dead_clicks: false,
  capture_exceptions: false,
  capture_heatmaps: false,
  enable_heatmaps: false,
  enable_recording_console_log: false,
  disable_session_recording: true,
  disable_surveys: true,
  disable_web_experiments: true,
  disable_persistence: true,
  disable_external_dependency_loading: true,
  disable_surveys_automatic_display: true,
  disable_compression: undefined,
  disable_scroll_properties: true,
  before_send: (event) => {
    return null; //Do not send any events to PostHog
  },
});

export default posthog;
*/
